var shareText = {
  init: function () {
    $('h2').selectionSharer();
    $('h3').selectionSharer();
    $('p').selectionSharer();
  }
};
$(function () {
  shareText.init();
});